import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type Phone } from 'entities/Phone/model/Phone'
import { SettingsRoutes } from 'entities/ExportRouters'

export const resumeNumber = (phone: Phone): ActionItem => {
  return {
    icon: 'play1',
    text: 'Resume',
    onAction: () =>
      uiStore.changeRouteViaVue({
        path: `/${SettingsRoutes.root}/organization/numbers/text-enable-landline`,
        query: `phone=${phone.national_number}`,
      }),
  }
}
